import { AfterContentInit, Directive, ElementRef, inject, Input } from '@angular/core';

@Directive({
  selector: '[lhSharedDirectiveAutoFocus]',
  standalone: true,
})
export class SharedDirectiveAutofocusDirective implements AfterContentInit {
  private el = inject<ElementRef<HTMLElement>>(ElementRef);

  @Input() lhAutoFocus = false;

  public ngAfterContentInit() {
    if (this.lhAutoFocus === false) {
      return;
    }
    setTimeout(() => this.requestElementFocus(), 350);
  }

  private requestElementFocus() {
    try {
      this.el.nativeElement.focus();
    } catch {
      // Ignore
    }
  }
}
